export default __webpack_public_path__ + "d9413784f57f40ed1ac696aede325d19.webp";